module.exports = __webpack_public_path__ + "assets/hoppa4.jpg?675c1b514847867d14713381ea6b00d2";